import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PaymentSlipResponseDTO } from '../../interfaces/payment-slips.interface';
import { IPaginatedResponse } from '../../interfaces/api/responses.interface';

@Injectable({
  providedIn: 'root',
})
export class PaymentSlipService {
  private apiUrl = `${environment.apiUrl}/paymentSlips`;

  constructor(private http: HttpClient) {}

  getPaymentSlipById(id: number): Observable<any> { 
    return this.http.get<any>(`${this.apiUrl}/detailPaymentSlipById/${id}`);
  }  
  postPaymentSlipById(id: number): Observable<any> { 
    return this.http.post<any>(`${this.apiUrl}/detailPaymentSlip/${id}`, null);
  }  

  getAllPaymentSlips(
    filter: Record<string, unknown>
  ): Observable<IPaginatedResponse<PaymentSlipResponseDTO>> {
    return this.http.post<IPaginatedResponse<PaymentSlipResponseDTO>>(this.apiUrl + '/listPaymentSlipByEmployee', filter);
  }

  updateStatePaymentSlip(idPaymentSlip: number, data: FormData) : Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/changeStatePaymentSlip/${idPaymentSlip}`, data);
  }

}
